import { MONTH_NAME_LIST } from './date.constants';

export const startFirstDayOfYear = (date: Date): Date => {
	const year = date.getFullYear();
	return new Date(year, 0, 1);
};

export const endLastDayOfYear = (date: Date): Date => {
	const year = date.getFullYear();
	return new Date(year, 11, 31, 23, 59, 59, 999);
};

export const startOfDay = (date: Date): Date => {
	const result = new Date(date);
	result.setHours(0, 0, 0, 0);
	return result;
};

export const endOfDay = (date: Date): Date => {
	const result = new Date(date);
	result.setHours(23, 59, 59, 999);
	return result;
};

export const isAgeValid = (selectedDate: Date, ageThreshold: number): boolean => {
	if (!selectedDate) return false;

	const birthDate = new Date(selectedDate);
	const today = new Date();

	const age = today.getFullYear() - birthDate.getFullYear();

	// Adjust age if birthday hasn't occurred this year
	const monthDiff = today.getMonth() - birthDate.getMonth();
	if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
		return age - 1 >= ageThreshold;
	}

	return age >= ageThreshold;
};

/**
 * Helper to convert a month name to its index using the shared MONTH_NAME_LIST.
 * Kept internal to avoid leaking implementation details.
 */
export const getMonthIndexFromName = (name: string): number => {
	return MONTH_NAME_LIST.indexOf(name.toUpperCase());
};

export function getDifferenceDay(from: Date | number, to: Date | number): number {
	const diffTime = new Date(to).getTime() - new Date(from).getTime();
	const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	return Math.abs(diffDays);
}
